import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { StatusEffect } from '../../status-effects.type';
import { addModifier } from '../../player.type';
import { randomInt } from '../../../utils/math';
import { DieFace } from '../../face.type';

export class CorestoneGuardianTrait extends Trait {
  static baseType = TraitType.CorestoneGuardian;
  static baseTitle = 'Corestone Guardian';
  static baseText =
    'At the start of each round, gain 1 Imbue & 1 Infusion of a random elemental effect.';
  static baseIcon = 'trait';

  type = CorestoneGuardianTrait.baseType;
  title = CorestoneGuardianTrait.baseTitle;
  text = CorestoneGuardianTrait.baseText;
  icon = CorestoneGuardianTrait.baseIcon;

  startTurn(): void {
    const elements: Array<[DieFace, StatusEffect]> = [
      [DieFace.Fire, StatusEffect.Burning],
      [DieFace.Ice, StatusEffect.Freezing],
      [DieFace.Lightning, StatusEffect.Spark],
      [DieFace.Earth, StatusEffect.Brittle],
    ];
    let [face, element] = elements[randomInt(0, 3)];
    addModifier(this.owner, StatusEffect.Imbue, 1, { imbue: element });
    addModifier(this.owner, StatusEffect.Infusion, 1, { infusion: face });
  }
}

TraitRegistry.register(CorestoneGuardianTrait.baseType, CorestoneGuardianTrait);
